module.exports = __webpack_public_path__ + "img/max-file-repeat--json.ad596e34.svg";